//

const subscriptions = new WeakMap();

export default subscriptions;
